import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import { NotifyFormat } from '@upstart/harmony/lib/legos/constants';
import {
  OutreachForm,
  PreviewFormat,
} from '@upstart/harmony/lib/legos/outreachTypes';

import BackendService from './BackendService';

export default class OutreachFormService {
  static getOutreachForm(dealerId: DealerId, templateId: NotifyFormat) {
    return BackendService.get(`/outreachForms/${dealerId}/${templateId}`);
  }

  static getOutreachForms(dealerId: DealerId) {
    return BackendService.get(`/outreachForms/${dealerId}/all`);
  }

  static getOutreachFormsStatus(dealerId: DealerId) {
    return BackendService.get(`/outreachForms/${dealerId}/status`);
  }

  static previewOutreachForm(
    outreachForm: OutreachForm,
    format: PreviewFormat,
  ) {
    const params = { format };
    return BackendService.put(
      `/outreachForms/${outreachForm.dealerId}/${outreachForm.templateId}/preview`,
      {
        params,
        body: outreachForm,
      },
    );
  }

  static updateOutreachForm(outreachForm: OutreachForm) {
    return BackendService.put(
      `/outreachForms/${outreachForm.dealerId}/${outreachForm.templateId}`,
      {
        body: outreachForm,
      },
    );
  }
}
